import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { FeatureFlagsState } from './state';

const getters: GetterTree<FeatureFlagsState, RootState> = {
  enrollmentsUgEnableCountyField: (state, getters) => {
    return state['enrollments-ug-enable-county-field'];
  },
};

export default getters;
